import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { getOrderInfo } from '../ordersThunk';
import { Order, OrdersState } from '../types';
import { CustomError } from 'shared/api';

export const getOrderInfoReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(getOrderInfo.pending, (state, action) => {
			// state.loadingDetail = true;
			state.selectedOrderInfoId = action.meta.arg.id;
		})
		.addCase(
			getOrderInfo.fulfilled,
			(state, action: PayloadAction<Order>) => {
				// state.loadingDetail = false;
				state.orderInfoDetail = action.payload;
				state.orderInfoDetailPerson = action.payload.person;
				state.error = null;
			},
		)
		.addCase(
			getOrderInfo.rejected,
			(state, action: PayloadAction<CustomError | undefined>) => {
				// state.loadingDetail = false;
				if (action.payload) {
					state.error = action.payload;
				}
			},
		)
};